/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const EventsRouter = {
  path: '/admin/events',
  component: Layout,
  redirect: '/admin/events/class/list',
  name: 'EventManager',
  meta: {
    title: 'Class Management',
    icon: 'peoples',
    permissions: ['event-manager-view']
  },
  children: [
    {
      path: 'main',
      component: () => import('@/views/events/main/list'),
      name: 'MainList',
      meta: {
        title: 'Class Management',
        icon: 'list',
        permissions: ['event-main-list-view']
      }
    },
    {
      path: 'history',
      component: () => import('@/views/events/history/list'),
      name: 'HistoryList',
      meta: {
        title: 'Class History',
        icon: 'list',
        permissions: ['event-history-list-view']
      }
    },
    {
      path: 'course',
      component: () => import('@/views/events/course/list'),
      name: 'CourseList',
      meta: {
        title: 'Course Management',
        icon: 'list',
        permissions: ['event-course-list-view']
      }
    },
    // {
    //   path: 'article',
    //   component: () => import('@/views/events/article/list'),
    //   name: 'ArticleList',
    //   meta: {
    //     title: '特選文章',
    //     icon: 'list',
    //     permissions: ['event-article-list-view'],
    //     hidden: true
    //   }
    // },
    {
      path: 'pay/create',
      component: () => import('@/views/events/pay/create'),
      name: 'PayCreate',
      meta: {
        title: 'Buy Credits',
        icon: 'list',
        permissions: ['event-pay-create-view']
      }
    },
    {
      path: 'pay/record',
      component: () => import('@/views/events/pay/record'),
      name: 'Record',
      meta: {
        title: 'My Credits',
        icon: 'list',
        permissions: ['event-pay-racord-view']
      }
    },
    {
      path: 'pay/checkout',
      component: () => import('@/views/events/pay/checkout'),
      name: 'PayCheckout',
      hidden: true,
      meta: {
        title: 'Checkout',
        icon: 'list',
        permissions: ['event-pay-create-view']
      }
    }
  ]
}
export default EventsRouter
